import dynamic from 'next/dynamic';
// import FloatPic from '@elem/compCommon/FloatPic';
import A from './components/A';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function PowerBackup() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`outdoor-recreation ${css['outdoor-recreation']}`}>
            <A />
            <IndexDynamic />
            {/* <FloatPic /> */}
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
